import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-12 bg-surface border-y border-white/5" data-id="element-354">
      <div className="container mx-auto px-4" data-id="element-355">
        {/* Stats Bar */}
        <FadeIn data-id="element-356">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-16" data-id="element-357">
            <div className="flex flex-col items-center text-center px-4" data-id="element-358">
              <Users className="w-8 h-8 text-gold mb-3" data-id="element-359" />
              <span className="text-2xl font-bold text-white font-heading" data-id="element-360">
                +1.200
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-361">
                Familias
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-362">
              <BookOpen className="w-8 h-8 text-gold mb-3" data-id="element-363" />
              <span className="text-2xl font-bold text-white font-heading" data-id="element-364">
                6
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-365">
                Módulos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-366">
              <Gift className="w-8 h-8 text-gold mb-3" data-id="element-367" />
              <span className="text-2xl font-bold text-white font-heading" data-id="element-368">
                4
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-369">
                Bonos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-370">
              <div className="flex gap-1 mb-3" data-id="element-371">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow text-yellow" data-id="element-372" />)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-373">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-374">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-375">
          <FadeIn delay={0.1} data-id="element-376">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-377">
              <div className="flex gap-1 mb-4" data-id="element-378">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow text-yellow" data-id="element-379" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-380">
                "En tres días de usar el Protocolo Sin Palabras, mi hijo dejó de
                encerrarse sin decir nada. No lo podía creer."
              </p>
              <div className="flex items-center gap-3" data-id="element-381">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-382">
                  M
                </div>
                <div data-id="element-383">
                  <p className="font-bold text-white text-sm" data-id="element-384">Marcela G.</p>
                  <p className="text-xs text-gray-500" data-id="element-385">Córdoba</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-386">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-387">
              <div className="flex gap-1 mb-4" data-id="element-388">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow text-yellow" data-id="element-389" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-390">
                "El Módulo de Ansiedad 911 fue exactamente lo que necesitaba
                para los ataques de pánico de mi hija antes de los exámenes.
                Concreto, práctico y funciona."
              </p>
              <div className="flex items-center gap-3" data-id="element-391">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-392">
                  L
                </div>
                <div data-id="element-393">
                  <p className="font-bold text-white text-sm" data-id="element-394">Laura P.</p>
                  <p className="text-xs text-gray-500" data-id="element-395">Rosario</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-396">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-397">
              <div className="flex gap-1 mb-4" data-id="element-398">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow text-yellow" data-id="element-399" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-400">
                "Tenía 15 años sin poder hablar más de 5 minutos con mi hijo sin
                que termine en grito. El Plan de 30 Días cambió todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-401">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-402">
                  R
                </div>
                <div data-id="element-403">
                  <p className="font-bold text-white text-sm" data-id="element-404">Roberto M.</p>
                  <p className="text-xs text-gray-500" data-id="element-405">Buenos Aires</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}